export default class LotDto {
    constructor(lotData) {
        this.companyId = lotData?.company?.id ?? '';
        this.productId = lotData?.product?.id ?? '';
        this.lotNumber = lotData?.lotNumber ?? '';
        this.supplierLotNumber = lotData?.supplierLotNumber ?? '';
        this.manufacturingDate = lotData?.manufacturingDate ?? '';
        this.dluo = lotData?.dluo ?? '';
    }
}